import styled from 'styled-components';

export const StyledPatientPresenceField = styled.div`
   width: 221px;
`;
StyledPatientPresenceField.displayName = 'StyledPatientPresenceField';
